import React from 'react'
import * as R from 'ramda'

import { getTraitTranslation } from 'components/modals/TestsReportModal/tabs/helpers'
import { TRAITS } from 'components/common/ScoreCard/ScoreCard'
import { formatTimeVerbose } from 'utils/stringFormat'

const useFactorData = ({ traits }) => {
  const [attributes, setAttributes] = React.useState(
    R.reduce((acc, key) => ({ ...acc, [key]: R.F() }), {}, traits),
  )

  const isAllOpened = React.useMemo(
    () => R.all(R.equals(true), R.values(attributes)),
    [attributes],
  )

  const handleToggle = React.useCallback(trait => {
    setAttributes(attributes => ({
      ...attributes,
      [trait]: R.not(attributes[trait]),
    }))
  }, [])

  const handleToggleAll = React.useCallback(() => {
    setAttributes(attributes => {
      if (isAllOpened) return R.map(R.F, attributes)

      if (!isAllOpened) return R.map(R.T, attributes)

      return attributes
    })
  }, [isAllOpened])

  return {
    state: { attributes, isAllOpened },
    handlers: { handleToggle, handleToggleAll },
  }
}

export const useFactorState = state => {
  const { factor, language, scores, stats } = state

  const { correct, seconds, totalAnswers, totalQuestions } = stats ?? {}

  const score = R.prop(factor, scores)

  const { label, abstract = [], description = [] } = getTraitTranslation(
    factor,
    score,
    language,
  )

  const traits = TRAITS[factor]

  const traitsCount = R.length(traits)

  const time = formatTimeVerbose(seconds)

  const {
    state: { attributes, isAllOpened },
    handlers: { handleToggle, handleToggleAll },
  } = useFactorData({ traits })

  return {
    state: {
      abstract,
      attributes,
      correct,
      description,
      label,
      score,
      time,
      totalAnswers,
      totalQuestions,
      traits,
      traitsCount,
      isAllOpened,
    },
    handlers: { handleToggle, handleToggleAll },
  }
}
